// extracted by mini-css-extract-plugin
export default {"container":"GeoMapHandler_container__kGk83","title":"GeoMapHandler_title__V4CVe","tag":"GeoMapHandler_tag__hOkGB"};